/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {formatLocaleNumber} from '../locale/locale-number-format';

export function formatAdnNumber(stat: any, locale = 'en'): number | string {
  if (_.isNull(stat) || _.isNaN(stat) || _.isUndefined(stat) || (_.isObject(stat) && _.isEmpty(stat))) {
    return 0;
  }
  return formatLocaleNumber(stat, undefined, locale);
}
